import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import {
  DashboardService,
  EncryptService,
  ProfileService,
  PublicDataService,
} from '../core/services';
import { Response } from '../utils/interfaces';
import { DataUser } from '../utils/models';

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard implements CanActivate {
  dataUser: DataUser;
  nickName: string;
  maxService: number;
  statusPlan: boolean;
  constructor(
    private readonly encrypt: EncryptService,
    private readonly dashboard: DashboardService,
    private readonly publicData: PublicDataService,
    private readonly profile: ProfileService
  ) {
    this.dataUser = new DataUser();
    this.nickName = '';
    this.maxService = 0;
    this.statusPlan = false;
  }

  async canActivate(): Promise<boolean> {
    this.buildUserData();
    await this.getNickName();
    await this.getUserPlan();
    return true;
  }

  private buildUserData(): void {
    this.dataUser =
      this.encrypt.getSession() !== ''
        ? this.encrypt.getSession()
        : new DataUser();
  }

  private getNickName(): Promise<void> {
    return new Promise((resolve) => {
      this.dashboard
        .getUserDataById(this.dataUser.idUsuario, this.publicData.idioma)
        .subscribe((response) => {
          if (response.message === 'OK' && response.status === 1) {
            this.nickName = response.objectResult[0] != undefined ? response.objectResult[0].nickName : '';
            this.profile.dataUser = this.dataUser;
            this.profile.nickName = this.nickName;
            this.profile.headers = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.dataUser.token}`,
              }),
            };
            resolve();
          }
        });
    });
  }

  private getUserPlan(): Promise<void> {
    return new Promise((resolve) => {
      this.publicData
        .getUserPlan(this.dataUser.idUsuario, this.publicData.idioma)
        .subscribe((response: Response) => {
          if (response.status === 1 && response.message === 'OK') {
            this.profile.planUser = response.objectResult[0];
            
            if(response.objectResult[0] != undefined) {
              this.profile.servicesUser = response.objectResult[0].servicios.split(' ')[2];
            }
            
            resolve();
          }
        });
    });
  }
}
